export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How do I receive the materials?',
    answer:
      'Instantly. The moment your payment is confirmed you get access to download all six volumes and the five bonuses as PDFs.',
  },
  {
    question: 'Do I need to be a qualified tennis coach to use this?',
    answer:
      'No. Every drill is written step by step with setup, timing, coaching cues and common errors, so any teacher or instructor can run it confidently.',
  },
  {
    question: 'What ages and levels does it cover?',
    answer:
      'Six progressive volumes take a player from first contact with the ball through to competition, suitable for juniors through adult beginners.',
  },
  {
    question: 'Do I need a tennis court to teach these lessons?',
    answer:
      'Not for everything. Many drills are designed for a hall, playground or half court, and each one lists the space and equipment it needs.',
  },
  {
    question: 'What format are the books in?',
    answer:
      'High-quality PDFs, formatted for both A4 printing and clean reading on a tablet or phone.',
  },
  {
    question: 'Can I print them or use them digitally?',
    answer:
      'Both. Print a full volume, print a single lesson plan, or teach straight from a screen on court.',
  },
  {
    question: 'Can I use this with a whole group or a squad?',
    answer:
      'Yes. Every drill includes variants for 2, 4 and 8 players plus squad-sized adaptations.',
  },
  {
    question: 'Is there a refund policy?',
    answer:
      'Yes. You have 30 days. If Tennis Ready does not save you hours of prep, email us for a full refund and keep every volume.',
  },
]
